import api from './base/BaseApi';
import { handleApiError } from './base/handleApiError';

type CreateWebSessionBody = {
  sessionId: string;
  oldSessionId?: string;
};

type LoginWebSessionBody = {
  sessionId: string;
};

type AcknowledgeWebSessionBody = {
  accountId: string;
};

export type GetWebSessionResponse = {
  id: string | null;
  token: string | null;
  intercomUserToken: string | null;
  accessToken: string | null;
  csrfToken: string | null;
};

export const storeWebSession = async (data: { currentKey: string; oldKey?: string }) =>
  api
    .post<null, CreateWebSessionBody>('api/v1/web-sessions', {
      sessionId: data.currentKey,
      oldSessionId: data.oldKey
    })
    .then((response) => response)
    .catch(handleApiError);

export const loginWebSession = async (key: string) =>
  api
    .post<GetWebSessionResponse, LoginWebSessionBody>(`api/v1/web-sessions/login`, {
      sessionId: key
    })
    .then((response) => response)
    .catch(handleApiError);

export const deleteWebSession = async () =>
  api
    .delete<null, null>(`api/v1/web-sessions/logout`)
    .then((response) => response)
    .catch(handleApiError);

export const acknowledgeWebSession = async (sessionId: string, accountId: string) =>
  api
    .patch<null, AcknowledgeWebSessionBody>(`api/v1/web-sessions/${sessionId}`, {
      accountId: accountId
    })
    .then((response) => response)
    .catch(handleApiError);
